module.exports = __webpack_public_path__ + "52e3f329929f4eafd842a68299217745.svg";